import React, { useRef, useEffect, useCallback, useState} from 'react';
import Documented from 'components/help/Documented.js';
import MacroOverlay from './MacroOverlay.js';
import {PIANO_ROLL} from 'constants/arrangement-modes.js';
import {sleep} from 'utils/sleep.js';
import {connect} from 'react-redux';
import {
    setTrackAutomationParameter,
    setArrangementBottomMode,
    setParameterToMap,
    setShowPianoRoll,
    setShowAutomation,
       } from 'actions/index.js';

const WHOLE = 1;
const DECIMAL = 2;

const FMParameter = ({
    name,
    value,
    className,
    parameter,
    hasAutomations,
    setShowPianoRoll,
    setBottomMode,
    setShowAutomation,
    setTrackAutomationParameter}) => { 
    let [yPosition, setYPosition] = useState(0);
    let changing = useRef(false);
    let dist = useRef(0);

    const showAutomations = useCallback(() => {
        setShowAutomation(true);
        setShowPianoRoll(true);
        setBottomMode(PIANO_ROLL);
        if (parameter.track) {
            let track = parameter.track.instrumentRack ?
                parameter.track.instrumentRack : parameter.track;
            setTrackAutomationParameter(track.id, parameter);
        }
    }, [parameter]);

    const onMouseDown = useCallback(async (e, part=WHOLE) => {
        let y = e.clientY;
        setYPosition(y);
        dist.current = 0;
        changing.current = part;

        while (changing.current) {
            let d = Math.pow(dist.current, 2);
            if (dist.current < 0) {
                d = -d;
            }
            let v = parameter.get();
            let whole = Math.floor(v);
            let decimal = Math.round(1000 * (v - whole));
            if (part === WHOLE) {
                whole = Math.round(whole - d / 40.0);
            } else {
                decimal = Math.round(decimal - d / 40.0);
            }
            let newValue = whole + (decimal / 1000.0);
            if (newValue >= 0) {
                parameter.set(newValue);
            }
            await sleep(100);
        }

    }, [parameter, setYPosition]);

    const onMouseUp = useCallback((e) => {
        changing.current = undefined;
    }, []);

    const onMouseMove = useCallback((e) => {
        if (changing.current) {
            dist.current = e.clientY - yPosition;
        }
    }, [yPosition]);

    let whole = Math.floor(value);
    let decimal = Math.round(1000 * (value - whole));
    return (
        <Documented
          element={parameter}
          className={"fm-parameter " + className}>
          <MacroOverlay parameter={parameter}/>
          <div>
            {name}
          </div>
          <div className="values">
            <div
              onMouseDown={(e) => onMouseDown(e, WHOLE)}
              onMouseUp={onMouseUp}
              onMouseLeave={onMouseUp}
              onMouseMove={onMouseMove}
              className="whole-value">
              {whole}
            </div>
            <div className="dot-value">
              .
            </div>
            <div
              onMouseDown={(e) => onMouseDown(e, DECIMAL)}
              onMouseUp={onMouseUp}
              onMouseLeave={onMouseUp}
              onMouseMove={onMouseMove}
              className="decimal-value">
              {getDecimalString(decimal)}
            </div>
          </div>
          {hasAutomations ? <img
                              className="automation-icon"
                              onClick={showAutomations} src="/automation-icon-disabled.png"/> : ''}
        </Documented>
    );
}

const mapStateToProps = (state, props) => {
  return {
      value: props.parameter.get(),
      hasAutomations: props.parameter.automations &&
          props.parameter.automations.length > 0,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
        setShowPianoRoll: p => dispatch(setShowPianoRoll(p)),
        setShowAutomation: p => dispatch(setShowAutomation(p)),
        setTrackAutomationParameter: (id, parameter) =>
            dispatch(setTrackAutomationParameter(id, parameter)),
        setBottomMode: (bottomMode) =>
            dispatch(setArrangementBottomMode(bottomMode))
  };
};

function getDecimalString(decimal) {
    let s = decimal.toString();
    while (s.length < 3) {
        s = "0" + s;
    }
    return s;
}

export default connect(mapStateToProps, mapDispatchToProps)(FMParameter);
